import {FormProvider} from '@yandex-delivery/form'
import clsx from 'clsx'
import React from 'react'
import {Helmet} from 'react-helmet'

import {Footer, Header} from 'src/entities/desktop'
import {appConfig} from 'src/shared/config'
import {ExistingOrderDetector} from 'src/widgets/desktop'

import {AsyncDefaultValues} from '../AsyncDefaultValues/AsyncDefaultValues'
import {OrderForm} from '../OrderForm/OrderForm'
import * as classes from './HomePage.classes'
import {getDefaultValues} from './HomePage.hooks'
import {FormSchema} from './schema/desktop'
import {seoConsts} from './seo-consts'
import {makeCanonicalUrl} from './utils/make-canonical-url'

export function HomePage(): React.ReactElement {
  const defaultValues = getDefaultValues()
  const {initialProps, tld, origin} = appConfig
  const {zoneName, tariff} = initialProps

  // BROWSER=none REACT_APP_BDUI=true npm start --silent
  return (
    <>
      <Helmet>
        <title>{appConfig.seo?.title ?? seoConsts.title}</title>
        <meta content={appConfig.seo?.description ?? seoConsts.description} name="description" />
        <link href={makeCanonicalUrl(origin, zoneName, tariff)} rel="canonical" />
      </Helmet>
      {/* todo: Узнать у Таси про поведение хедера при оверскролле,
          если он должен оставаться на месте то использовать пропс isFixed у Header */}
      <Header />
      <main className={clsx(classes.content, {[classes.contentRu]: tld === 'ru'})}>
        <FormProvider defaultValues={defaultValues} validationSchema={FormSchema} debug>
          <AsyncDefaultValues defaultValues={defaultValues} />
          <ExistingOrderDetector />
          <OrderForm />
        </FormProvider>
      </main>
      <Footer />
    </>
  )
}
